import React, { useState } from 'react';
import '../css/contactForm.css';

const ContactUs = () => (
    <section className="contact-section">
      <div className="contact-content">
        <div className="contact-item">
          <h4>Address</h4>
          <p>13730 Town Line Road,<br /> Silver Spring, MD</p>
        </div>
  
        <div className="contact-item">
          <h4>Email</h4>
          <p>
            <a href="mailto:madhavakunti@gmail.com">madhavakunti@gmail.com</a>
          </p>
        </div>
  
      {/*  <div className="contact-item">
          <h4>Phone</h4>
          <p>
            <a href="tel:+14102422299">+1 000-000-0000</a>
          </p>
        </div> */}

      </div>
    </section>
  );
  
  export default ContactUs;